// src/admin/components/EmptyState.tsx
// Centered "no data here" placeholder. The optional icon slot renders inside a
// soft tile above the title — used by the loan detail tabs and any other
// surface that needs a friendlier empty state than a single line of text.
import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

interface Props {
  title: string;
  body?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export default function EmptyState({ title, body, icon, action }: Props) {
  return (
    <div className={styles.box}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <h3>{title}</h3>
      {body && <p>{body}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
